import type { PhoneBundle } from '../format/phone';
import { useLocalizationContext } from './useLocalizationContext';

/**
 * The reader's own phone country, for a phone field to start on.
 *
 * Identity holds for as long as the preferences do, so it is safe in a dependency array.
 *
 * @returns The bundle. See {@link PhoneBundle}.
 * @throws If no `<LocalizationProvider>` is mounted above the caller.
 */
export const usePhone = (): PhoneBundle => useLocalizationContext().phone;
